module.exports = __webpack_public_path__ + "img/kp.e42591ef.png";